module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/repertorio_big.cf8ca7b0.png";